import { HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { defaultLanguage } from '@data/lang';
import { loginEndpoints } from '@data/network.data';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class MethodsGeneralService {
  private readonly authHeader = 'Authorization';
  private readonly timeoutHeader = 'timeout';
  private readonly acceptLanguage = 'Accept-Language';
  private readonly idpSub = 'idpSub';
  private readonly managementGroup = 'managementGroup';
  private readonly subscription = 'subscription';
  private readonly token = '/token';

  getHeaders(
    request: HttpRequest<unknown>,
    token: string,
    authorization: string,
    currentlanguage: string,
    idpSub: string,
    subscription: string,
    activeManagementGroupId: string,
    body: any
  ): HttpRequest<unknown> {

    if (
      request.url.includes('https://maps.googleapis.com') ||
      request.url === environment.urlDriverPasserPrint
    ) {
      return request;
    }

    const {
      serverUrlAdmin,
      serverUrlPasser,
      serverUrlDriver,
      serverServices,
      serverAdmin,
      serverStats,
      serverUrl: serverAdminSubscription,
      passerIdP: {
        options: { serverUrl },
      },
    } = environment;

    const isApiUrl =
      (!request.url.startsWith(serverUrl) &&
        !request.url.startsWith(serverUrlAdmin) &&
        !request.url.startsWith(serverAdminSubscription) &&
        !request.url.startsWith(serverUrlPasser) &&
        !request.url.startsWith(serverUrlDriver) &&
        !request.url.startsWith(serverServices) &&
        !request.url.startsWith(serverStats) &&
        !request.url.startsWith(serverAdmin)) ||
      request.url.startsWith(`${serverUrl}${this.token}`);
  
    const contentType = request.headers.get('Content-type') ?? 'application/json; charset=UTF-8';
    const headers = request.headers
      .set(this.timeoutHeader, `${60000}`)
      .set(this.acceptLanguage, currentlanguage || defaultLanguage)
      .set('version', environment.desVersion)
      .set('Content-type', contentType)
      .set('Access-Control-Allow-Origin', '*')
      .set('Access-Control-Allow-Headers', 'Origin, X-Requested-With, Content-Type, Accept, access-control-allow-origin')
      .set('Access-Control-Allow-Credentials', 'true')
    if (isApiUrl || !token) {
      return request.clone({headers, body});
    }
  
    return request.clone({
      body,
      headers: headers
        .set(this.authHeader, authorization)
        .set(this.idpSub, idpSub || '')
        .set(this.managementGroup, activeManagementGroupId || '')
        .set(this.subscription, subscription || '')
    });
  }

  setAuthorizationRetry(auth: string, token: string, tokenType: string): string {
    const splitAuth = auth.split(' ');
    switch (splitAuth[0]) {
      case 'Basic': {
        const authString = btoa(`${environment.passerIdP.options.clientId}:${environment.passerIdP.options.clientsecret}`);
        return `Basic ${authString}`;
      }
      case 'Bearer': {
        return auth;
      }
      default: return tokenType ? `${tokenType} ${token}` : '';
    }
  }

  isLoginEndpoint(url: string): boolean {
    const requestFound = Object.values(loginEndpoints).some(value => url.includes(value));
    if (requestFound) {
      return true;
    }
  
    return false;
  }

  toQueryString(query, timezone = true): string {
    const parts = [];
    const finalData = {...query};
    if (timezone) {
      finalData.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    for (const property in finalData) {
      const value = finalData[property];
      if (value != null && value != undefined)
        parts.push(
          encodeURIComponent(property) + '=' + encodeURIComponent(value)
        );
    }

    return parts.join('&');
  }

  gotToNewTab(url: string = ''): void {
    window.open(
      url,
      '_blank',
      'noopener,noreferrer'
    )?.focus();
  }

  downloadFile(href: string, name: string): void {
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = href;
    a.download = name;
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  validMultioperationError(data: {multi_operation: boolean;}): boolean {
    return (data != null &&
        typeof data === 'object' &&
        typeof (data as any).multi_operation === 'boolean'
      );
  }
}
